import { useState } from 'react';

const useEditSave = (initialState = false) => {
  const [isEditMode, setIsEditMode] = useState(initialState);

  const toggleMode = () => setIsEditMode((prev) => !prev);

  const saveData = async (onSave) => {
    setIsEditMode(true);
    try {
      await onSave();
    } catch (error) {
      console.error('Save failed:', error);
    }
  };

  return { isEditMode, toggleMode, saveData };
}

export default useEditSave;
